import config from "../../configurations";
import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Col, Row, Spinner, Alert } from "react-bootstrap";
import AuthHelper from "../../helpers/AuthHelper";
import FluentdHelper from "../../helpers/FluentdHelper";
import {
  CODE_MISMATCH_EXCEPTION,
  DANGER,
  EMPTY,
  LOGERROR,
  MC003,
  MC004,
  MC005,
  MC006,
} from "../../configurations/Constants";
import {
  CONFIRM_ACCOUNT,
  ENTER_PASSWORD,
  ENTER_VERIFICATION_CODE,
  ENTER_VERIFICATION_CODE_RECEIVED,
  ERROR_AUTO_SIGNING_FOR_USER,
  ERROR_CONFIRMING_USER,
  ERROR_CREATING_USER,
  ERROR_HAS_OCCURED,
  ERROR_RESENDING_CODE_FOR_USER,
  ERROR_TRY_AFTER_SOMETIME,
  FAILED_SIGN_UP_CONTACT_ADMIN,
  FINISH_SETTING_UP_ACCOUNT_CREATE_PASSWORD,
  GENERATE_PASSWORD,
  INVALID_VERIFICATION_CODE,
  MOBILE_NUMBER_REGISTERED,
  PASSWORD_DO_NOT_MATCH,
  PASSWORD_EIGHT_CHARACTERS,
  RE_ENTER_PASSWORD,
  SIGNUP_CODE_NOT_VALID,
  SUCCESSFULLY_AUTO_SIGNED_IN_FOR_USER,
  SUCCESSFULLY_RESEND_CODE_FOR_USER,
  USER_EMAIL_REGISTERED,
} from "../../configurations/MessageConstants";
import { StatusCodes } from "../../configurations/status-codes";
const { FARMER_MOBILE_PREFIX } = config;
function PasswordPopUp(props) {
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState(EMPTY);
  const [confirmPassword, setConfirmPassword] = useState(EMPTY);
  const [verified, setVerified] = useState(false);
  const [verificationCode, setVerificationCode] = useState(EMPTY);
  const [verificationCodeError, setVerificationCodeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(EMPTY);
  const [btnUserClicked, setBtnUserClicked] = useState(false);
  const [btnConfirmClick, setBtnConfirmClick] = useState(false);
  const [AuthError, setAuthError] = useState(false);
  const [showpassword, setShowpassword] = useState(false);
  const [alertMessage, setAlertMessage] = useState(ERROR_TRY_AFTER_SOMETIME);
  const [userCreationInprogress, setUserCreationInprogress] = useState(false);
  const [verificationResending, setVerificationResending] = useState(false);

  const resetState = () => {
    setValidated(false);
    setPassword(EMPTY);
    setConfirmPassword(EMPTY);
    setVerified(false);
    setVerificationCode(EMPTY);
    setVerificationCodeError(false);
    setErrorMessage(EMPTY);
    setBtnUserClicked(false);
    setBtnConfirmClick(false);
    setAuthError(false);
    setShowpassword(false);
    setAlertMessage(ERROR_TRY_AFTER_SOMETIME);
    setUserCreationInprogress(false);
  };

  const mounted = useRef(true);
  useEffect(() => {
    if (mounted.current) {
      //ComponentDidMount Logic
      mounted.current = false;
    } else {
      //ComponentDidUpdate Logic
      if (userCreationInprogress === true) {
        window.onbeforeunload = () => true;
      } else {
        window.onbeforeunload = undefined;
      }
    }
  });

  const toggleShowPassword = () => {
    setShowpassword(!showpassword);
  };

  const handleSubmitRequest = async (event) => {
    setBtnUserClicked(true);
    setUserCreationInprogress(true);
    const passwordForm = event.currentTarget;
    if (passwordForm.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      setBtnUserClicked(false);
      setUserCreationInprogress(false);
      return false;
    } else {
      event.preventDefault();
      event.stopPropagation();
      if (password !== confirmPassword) {
        setValidated(true);
        setBtnUserClicked(false);
        setUserCreationInprogress(false);
        return false;
      }
      setValidated(false);
      await signUp(event);
    }
  };

  const checkVerificationCode = (e) => {
    e.persist();
    setVerificationCode(e.target.value);
    setVerificationCodeError(false);

    if (e.target.value === EMPTY) {
      setVerificationCodeError(true);
    }
  };

  const signUp = async (event) => {
    const username = props.userEmail.toLowerCase().trim();
    const phone_number = `${FARMER_MOBILE_PREFIX}${props.userPhone.replace(
      /\D+/g,
      EMPTY
    )}`;
    const email = props.userEmail.toLowerCase().trim();
    const for_staff = props.skipPhoneVerification ? "1" : "0";
    try {
      const payload = {
        username,
        password,
        attributes: {
          email: email,
          phone_number: phone_number,
          "custom:for_staff": for_staff,
        },
      };
      const requestResponse = await props.onSubmit(event, password);
      if (
        requestResponse &&
        requestResponse.data &&
        requestResponse.data.code === StatusCodes.OK
      ) {
        FluentdHelper.logEvent(
          `User ${username} successfully created in Dynamodb, with skip verification as ${props.skipPhoneVerification}`,
          "FE_signUp",
          username,
          {
            request: payload,
            response: requestResponse,
          }
        );
        if (props.skipPhoneVerification === true) {
          setUserCreationInprogress(false);

          await handleAutoSignin();
          props.onVerified();
        } else {
          setVerified(true);
          setUserCreationInprogress(false);
        }
      } else if (
        requestResponse &&
        requestResponse.data &&
        requestResponse.data.code === StatusCodes.BAD_REQUEST
      ) {
        let errorMessage = ERROR_CREATING_USER;
        if (requestResponse.message_code === MC004) {
          errorMessage = SIGNUP_CODE_NOT_VALID;
        } else if (
          requestResponse.message_code === MC003 ||
          requestResponse.message_code === MC005
        ) {
          errorMessage = USER_EMAIL_REGISTERED;
        } else if (requestResponse.message_code === MC006) {
          errorMessage = MOBILE_NUMBER_REGISTERED;
        }
        setBtnUserClicked(false);
        setAuthError(true);
        setUserCreationInprogress(false);
        setAlertMessage(errorMessage);

        FluentdHelper.logEvent(
          `Error while creating user ${username}`,
          "FE_signUp",
          username,
          {
            request: payload,
            response: requestResponse,
          },
          LOGERROR
        );
      } else {
        FluentdHelper.logEvent(
          `Error while creating user ${username}`,
          "FE_signUp",
          username,
          {
            request: payload,
            response: requestResponse,
          },
          LOGERROR
        );
        setBtnUserClicked(false);
        setAuthError(true);
        setUserCreationInprogress(false);
        setAlertMessage(ERROR_TRY_AFTER_SOMETIME);
      }
    } catch (error) {
      FluentdHelper.logEvent(
        `Error while signing up user ${username}`,
        "FE_signUp",
        username,
        {
          request: { username: username, password: password },
          response: error,
        },
        LOGERROR
      );
      setBtnUserClicked(false);
      setAuthError(true);
      setUserCreationInprogress(false);
      console.error(ERROR_CREATING_USER, error);
    }
  };

  const handleResendCode = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVerificationResending(true);
    try {
      const response = await AuthHelper.resendSignUp(
        props.userEmail.toLowerCase().trim()
      );
      FluentdHelper.logEvent(
        `${SUCCESSFULLY_RESEND_CODE_FOR_USER} ${props.userEmail.toLowerCase()}`,
        "FE_handleResendCode",
        props.userEmail.toLowerCase(),
        {
          request: props.userEmail.toLowerCase(),
          response: response,
        }
      );
      setVerificationResending(false);
    } catch (error) {
      console.error(ERROR_RESENDING_CODE_FOR_USER, error);
      FluentdHelper.logEvent(
        `${ERROR_RESENDING_CODE_FOR_USER} ${props.userEmail.toLowerCase()}`,
        "FE_handleResendCode",
        props.userEmail.toLowerCase(),
        {
          request: props.userEmail.toLowerCase(),
          response: error,
        },
        LOGERROR
      );
      setVerificationResending(false);
    }
  };

  const handleAutoSignin = async () => {
    const username = props.userEmail.toLowerCase().trim();
    try {
      const response = await AuthHelper.SignIn(username, password, false);
      FluentdHelper.logEvent(
        `${SUCCESSFULLY_AUTO_SIGNED_IN_FOR_USER} ${props.userEmail.toLowerCase()}`,
        "FE_handleAutoSignin",
        props.userEmail.toLowerCase(),
        {
          request: {
            username: username,
            password: password,
          },
          response: response,
        }
      );
    } catch (error) {
      FluentdHelper.logEvent(
        `${ERROR_AUTO_SIGNING_FOR_USER} ${username}`,
        "FE_handleAutoSignin",
        props.userEmail.toLowerCase(),
        {
          request: {
            username: username,
            password: password,
          },
          response: error,
        },
        LOGERROR
      );
      setVerificationCodeError(true);
      setErrorMessage(FAILED_SIGN_UP_CONTACT_ADMIN);
      setBtnConfirmClick(false);
    }
  };

  const confirmSignUp = async (event) => {
    setBtnConfirmClick(true);
    event.preventDefault();
    event.stopPropagation();
    setVerificationCodeError(false);

    if (verificationCode !== EMPTY) {
      const username = props.userEmail.toLowerCase().trim();
      const code = verificationCode;
      try {
        const response = await AuthHelper.confirmSignUp(username, code);
        await handleAutoSignin();
        props.onVerified();
        FluentdHelper.logEvent(
          `The user ${username} successfully confirmed`,
          "FE_confirmSignUp",
          username,
          {
            request: {
              username: username,
              verificationCode: code,
            },
            response: response,
          }
        );
      } catch (error) {
        let responseData = error.response.data;
        if (responseData.message_code === CODE_MISMATCH_EXCEPTION) {
          FluentdHelper.logEvent(
            `${CODE_MISMATCH_EXCEPTION} ${ERROR_CONFIRMING_USER} ${username}`,
            "FE_confirmSignUp",
            username,
            {
              request: {
                username: username,
                verificationCode: code,
              },
              response: responseData,
            },
            LOGERROR
          );

          setVerificationCodeError(true);
          setErrorMessage(INVALID_VERIFICATION_CODE);
          setBtnConfirmClick(false);
        } else {
          FluentdHelper.logEvent(
            `${ERROR_CONFIRMING_USER} ${username}`,
            "FE_confirmSignUp",
            username,
            {
              request: {
                username: username,
                verificationCode: code,
              },
              response: error,
            },
            LOGERROR
          );
          setVerificationCodeError(true);
          setErrorMessage(ERROR_HAS_OCCURED);
          setBtnConfirmClick(false);
        }
      }
    } else {
      setVerificationCodeError(true);
      setErrorMessage(ENTER_VERIFICATION_CODE);
      setBtnConfirmClick(false);
    }
  };

  let _class = EMPTY;
  let errMessage = EMPTY;
  if (password !== confirmPassword) {
    _class = "is-invalid has-error";
    errMessage =
      confirmPassword === EMPTY ? RE_ENTER_PASSWORD : PASSWORD_DO_NOT_MATCH;
  } else {
    errMessage = RE_ENTER_PASSWORD;
    _class = EMPTY;
  }
  let closeModal = () => {};
  return (
    <Modal
      show={props.showPasswordPopup}
      onHide={closeModal}
      className="confirm-modal"
    >
      <Modal.Header>
        <h3>{!verified ? GENERATE_PASSWORD : ENTER_VERIFICATION_CODE}</h3>
      </Modal.Header>
      <Modal.Body>
        {AuthError && (
          <Alert
            variant={DANGER}
            onClose={() => setAuthError(false)}
            dismissible
          >
            {alertMessage}
          </Alert>
        )}
        <p color="muted">
          {!verified
            ? FINISH_SETTING_UP_ACCOUNT_CREATE_PASSWORD
            : CONFIRM_ACCOUNT}
        </p>

        {!verified && <p color="muted">{PASSWORD_EIGHT_CHARACTERS}</p>}

        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleSubmitRequest(e)}
        >
          {!verified ? (
            <div>
              <Row>
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="validationCustomPassword"
                >
                  <Form.Label>Password*</Form.Label>
                  <Form.Control
                    type={showpassword ? "text" : "password"}
                    name="password"
                    minLength="8"
                    value={password || EMPTY}
                    onChange={(e) => {
                      e.persist();
                      setPassword(e.target.value);
                    }}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {password === EMPTY
                      ? ENTER_PASSWORD
                      : password.length < 9
                      ? PASSWORD_EIGHT_CHARACTERS
                      : EMPTY}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="validationCustomPasswordconfirm"
                >
                  <Form.Label>Confirm Password*</Form.Label>
                  <Form.Control
                    type={showpassword ? "text" : "password"}
                    name="confirmPassword"
                    value={confirmPassword || EMPTY}
                    onChange={(e) => {
                      e.persist();
                      setConfirmPassword(e.target.value);
                    }}
                    required
                    className={_class}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} md="12">
                  <Form.Check
                    id="showPasswordId"
                    type="checkbox"
                    label="Show Password"
                    onChange={() => {
                      toggleShowPassword();
                    }}
                  />
                </Form.Group>
              </Row>
              <p className="text-muted">
                This will be your password for the TPNRD and AgHub Application
                Login.
              </p>
            </div>
          ) : (
            <div>
              <Row>
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="validationMobileVerificationCode"
                >
                  <Form.Label>Verification Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="verificationCode"
                    onChange={(e) => {
                      checkVerificationCode(e);
                    }}
                    value={verificationCode || EMPTY}
                    className={
                      verificationCodeError
                        ? "is-invalid invalidcontrol"
                        : verificationCode !== EMPTY
                        ? "is-valid"
                        : EMPTY
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    {errorMessage}
                  </Form.Control.Feedback>
                  <small className="resend-link">
                    {verificationResending === true ? (
                      <div>
                        <Spinner
                          as="div"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        <span> Sending</span>
                      </div>
                    ) : (
                      <Button
                        variant="link"
                        className="resend-link p-0 btn-link-small"
                        onClick={(e) => {
                          handleResendCode(e);
                        }}
                      >
                        Resend verification code
                      </Button>
                    )}
                  </small>
                </Form.Group>
              </Row>
              <p className="text-muted">{ENTER_VERIFICATION_CODE_RECEIVED}</p>
            </div>
          )}
          {!verified ? (
            <div>
              <Button type="submit" disabled={btnUserClicked}>
                {" "}
                {btnUserClicked ? (
                  <div>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    <span>Creating</span>
                  </div>
                ) : (
                  "Create User"
                )}
              </Button>{" "}
              <Button
                disabled={btnUserClicked}
                type="button"
                onClick={(e) => {
                  resetState();
                  props.closeModal();
                }}
              >
                Close
              </Button>{" "}
            </div>
          ) : (
            <Button
              disabled={btnConfirmClick}
              type="button"
              onClick={(e) => confirmSignUp(e)}
            >
              {btnConfirmClick ? (
                <div>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  <span>Verifying</span>
                </div>
              ) : (
                "Confirm Sign Up"
              )}
            </Button>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default PasswordPopUp;
